module.exports = __webpack_public_path__ + "static/media/kdb-banner-2.db16b44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner-2.png
// module id = 1275
// module chunks = 1